import jump from 'jump.js';

const min = 400;
const max = 2000;

[...document.querySelectorAll('.-js-jump')].forEach((item) => {
    item.addEventListener('click', (event) => {
        event.preventDefault();
        const href = item.getAttribute('href');

        jump(href, {
            duration: (distance) => {
                const value = Math.abs(distance) / 2;
                return value > max ? max : value < min ? min : value;
            },
        });
    });
});
